export default __webpack_public_path__ + "static/media/news5.bf3b716d.png";